import { notify } from '../utils/notification'
import { parseError, agent, updateSessionObject } from 'utils/api'
import constants from 'constants'
import { push } from 'react-router-redux'
import { getConfig } from 'utils/config'

export const TEMPLATE_UPLOAD_GET = 'TEMPLATE_UPLOAD_GET'
export const TEMPLATE_UPLOAD_RECEIVED = 'TEMPLATE_UPLOAD_RECEIVED'
export const TEMPLATE_UPLOAD_GET_ERROR = 'TEMPLATE_UPLOAD_GET_ERROR'
export const TEMPLATE_UPLOAD_DELETE_RECEIVED = 'TEMPLATE_UPLOAD_DELETE_RECEIVED'
export const TEMPLATE_UPLOAD_DELETE_COMPLETE = 'TEMPLATE_UPLOAD_DELETE_COMPLETE'

const fetching = type => ({
  type,
})

const fetchingerror = type => ({
  type,
})

const deleteTemplateRequest = () => ({
  type: TEMPLATE_UPLOAD_DELETE_RECEIVED,
})

const deleteTemplateComplete = result => ({
  result,
  type: TEMPLATE_UPLOAD_DELETE_RECEIVED,
})

const templateReceive = templateUploaded => ({
  type: TEMPLATE_UPLOAD_RECEIVED,
  templateUploaded,
})

const logPath = (path) => {
  const capLoansLib = getConfig().CAPITALLOAN_UPLOAD_LIBRARY
  const capLoansLibLogs = getConfig().CAPITALLOAN_UPLOAD_RUN_LOG

  return path.replace(capLoansLib, capLoansLibLogs).replace('.csv', '.txt')
}

const mapTemplateUpload = (result) => {
  const templateUploaded = result.map(template => ({
    itemId: template.ItemID,
    path: template.URL,
    logPath: (template.URL ? logPath(template.URL) : ''),
    status: template.Status,
    documentName: template.Name,
    created: template.Created,
    modified: template.Modified,
  }))
  return templateUploaded
}

export function sendNotification(message) {
  return (dispatch) => { 
    dispatch(notify(message))
  }
}

export function getTemplates(libraryName, folderName) {
  return (dispatch) => {
    dispatch(fetching(TEMPLATE_UPLOAD_GET))
    agent.Template.gettemplates(libraryName, folderName).then((response) => {
      dispatch(templateReceive(mapTemplateUpload(response)))
      // dispatch(notify('Successfully load admin centre'))
    }).catch((rawError) => {
      const { error, status, description } = parseError(rawError)
      if (status === constants.ERROR.INTERNAL_SERVER || status === constants.ERROR.SERVICE_UNAVAILABLE) {
        dispatch(push({
          pathname: '/error',
          search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
        }))
      } else if (status === constants.ERROR.UNAUTHORIZED) {
        updateSessionObject()
      } else {
        dispatch(notify(description))
        // console.warn('Err <getTemplates>: ', error)
        dispatch(fetchingerror(TEMPLATE_UPLOAD_GET_ERROR))
      }
    })
  }
}

export function deleteTemplate(itemId, libraryName, folderName) {
  return (dispatch) => {
    dispatch(deleteTemplateRequest())
    agent.FileUploader.deletetemplate(itemId, libraryName, folderName).then((response) => {
      dispatch(templateReceive(mapTemplateUpload(response)))
      dispatch(notify('Document deleted'))
    }).catch((rawError) => {
      const { error, status, description } = parseError(rawError)
      if (status === constants.ERROR.INTERNAL_SERVER || status === constants.ERROR.SERVICE_UNAVAILABLE) {
        dispatch(push({
          pathname: '/error',
          search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
        }))
      } else if (status === constants.ERROR.UNAUTHORIZED) {
        updateSessionObject()
      } else {
        dispatch(getTemplates(libraryName, folderName))
        dispatch(notify(description))
        // console.warn('Err <deleteTemplate>: ', error)
        dispatch(fetchingerror(TEMPLATE_UPLOAD_GET_ERROR))
      }
    })
  }
}




// WEBPACK FOOTER //
// ./src/actions/templateUpload.js